import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Leaves } from 'shared/lib/types';

import { BonusProgram } from 'entities/bonus-program';

type ObjectLeaves = Leaves<BonusProgram>;

export type TableColumns = Extract<
  ObjectLeaves,
  'name' | 'bonusProgramType' | 'dateStart' | 'dateStop'
>;

export type TableColumnsState = Record<TableColumns, boolean>;

const initialState: TableColumnsState = {
  name: true,
  bonusProgramType: true,
  dateStart: true,
  dateStop: true,
};

const slice = createSlice({
  name: 'bonusProgramsTable',
  initialState,
  reducers: {
    setVisibleColumns: (state, action: PayloadAction<TableColumnsState>) => {
      return action.payload;
    },
  },
});

export const { setVisibleColumns } = slice.actions;
export default slice.reducer;
